export default __webpack_public_path__ + "static/media/otterbg.6ce0d3ed.jpg";